{
  "error-block-header": "Ошибка в блоке {{id}}",
  "error-page-header": "Ошибка"
}
